/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getBoardMembers } from "../../api/apiServices";
import './Board.css';

const BOARD_URL = '/api/management/board';

function Board({ useCache }) {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const [board, setBoard] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [count, setCount] = useState(0);

    const pgNumber = [9, 18, 36, 99];
    const pgraphst = {
        WebkitLineClamp: pgNumber[count],
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        display: "-webkit-box",
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        getBoardMembers({
            company: "NTHC_Commodities_Ltd"
        }, { signal })
            .then((res) => {
                setBoard(res)
            });
        return () => {
            controller.abort();
        };
    }, [])
    console.log(board)
    // const body = board && board[1].profile.split("$")
    // console.log(body)

    return (
        <div className="content">
            <h3 className="heading"> Board of Directors</h3>
            <div className="board-container">
                {board && board.length > 0 && board.map((boardObj, index) => (
                    <div className="board-items">
                        <div className="info" key={index}>
                            <img src={`${process.env.REACT_APP_BASE_URL}/getimage/board/${boardObj.image}`} alt='board' />
                            <h2>{boardObj.name}</h2>
                            <p>{boardObj.position}</p>
                        </div>
                        <div className="profile">
                            <div style={isOpen ? null : pgraphst}>
                                {boardObj.profile && boardObj.profile.split("$").map((item, index) => (
                                    <div>
                                        {index == 0 ? (
                                            <>
                                                <p>{item && item}</p>
                                            </>
                                        ) : (
                                            <div>
                                                {boardObj.profile.length < boardObj.profile.length + 1 && (
                                                    <>
                                                        <p>{item && item}</p>
                                                    </>
                                                )}
                                            </div>

                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="read-more-less">
                                {boardObj.profile && (
                                    <button
                                        style={{ marginTop: "0.5rem", display: "" }}
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={() => getCountNumber(count, setCount)}
                                    >
                                        {count > 2 ? "Read less..." : "Read more..."}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default Board;

function getCountNumber(count, setCount) {
    if (count > 2) {
        setCount((count = 0));
    } else {
        setCount(count + 1);
    }
}
